import React from "react";
import { SORT_DIRECTIONS } from "../HyroTable.consts";
import SortButton from "../components/SortButton";

export default function useSorting() {
  const sortingOrder = [SORT_DIRECTIONS.ASC, SORT_DIRECTIONS.DESC, null];

  const sortingSlots = {
    columnSortedAscendingIcon: () => <SortButton direction={SORT_DIRECTIONS.ASC} />,
    columnSortedDescendingIcon: () => <SortButton direction={SORT_DIRECTIONS.DESC} />
  };

  return {
    sortingOrder,
    sortingSlots
  };
}
